export default __webpack_public_path__ + "static/media/LightgreensmallCircle.0b385c68.svg";